import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LOADER_CONTEXT } from '../../../../../services/interceptors/loader.interceptor';
import { DevicesPayload } from '../../../devices/components/devices.models';
import { MissingProgrammingRecordsListResponse } from './missing-programming-records-api.types';

@Injectable({ providedIn: 'root' })
export class MissingProgrammingRecordsApiService {
  private readonly httpClient = inject(HttpClient);

  readList(payload: DevicesPayload): Observable<MissingProgrammingRecordsListResponse> {
    return this.httpClient.post<MissingProgrammingRecordsListResponse>('/api/missing-records', payload, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }
}
